import _objectSpread from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createContext, useContext } from 'react';
export var CONTEXT_VERSION = 1;
export function createLeafletContext(map) {
  return Object.freeze({
    __version: CONTEXT_VERSION,
    map: map
  });
}
export function extendContext(source, extra) {
  return Object.freeze(_objectSpread(_objectSpread({}, source), extra));
}
export var LeafletContext = createContext(null);
export var LeafletProvider = LeafletContext.Provider;
export function useLeafletContext() {
  var context = useContext(LeafletContext);
  if (context == null) {
    throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
  }
  return context;
}